import { createContext, useState } from "react";

const OrderManagementContext = createContext();

const OrderManagementProvider = ({ children }) => {
    const [orderTotalCost, setOrderTotalCost] = useState({});
    const [userApprovalRange, setUserApprovalRange] = useState({});

    return (
        <OrderManagementContext.Provider value={{
            orderTotalCost,
            setOrderTotalCost,
            userApprovalRange,
            setUserApprovalRange,
        }}>
        {children}
        </OrderManagementContext.Provider>
    );
} 

export { OrderManagementContext, OrderManagementProvider };